import { useDocumentRename } from "@/domains/documents/hooks/useDocumentRename";
import { useFolderRename } from "@/domains/documents/hooks/useFolderRename";
import { useLanguage } from "@/lib/i18n/LanguageContext";

import type { documentTableOptions } from "./documentTableOptions";
type Options = Pick<
  ReturnType<typeof documentTableOptions>,
  "onRenameDocumentSubmit" | "onRenameFolder"
>;
export function useTableBasics(options: Options) {
  const { onRenameDocumentSubmit, onRenameFolder } = options;
  const { language, t } = useLanguage();
  const documentRename = useDocumentRename(async (id, newFilename) => {
    if (!onRenameDocumentSubmit) return;
    await onRenameDocumentSubmit(String(id), newFilename);
  });
  // Folder rows get the same inline-edit treatment as document rows: the menu
  // item only opens the editor, and the rename is submitted from the input.
  const folderRename = useFolderRename((folderId, newName) => {
    onRenameFolder?.(folderId, newName);
  });
  return { language, t, folderRename, documentRename };
}
